import React from 'react';
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import { combineMediaQueriesWithAnd } from '@configuratorware/configurator-frontendgui/Utils/Styles/combineMediaQueries';
import FullScreenView, { PreviewButton } from '../../../../Screens/Configurator/Components/FullScreenView';

export const useStyles = makeStyles(
  (theme) => ({
    viewsContainer: {
      width: '100%',
      '@media (max-height: 650px)': {
        bottom: 0,
      },
    },
    button: {
      [theme.breakpoints.down('sm')]: {
        bottom: 'auto',
      },
    },
    thumbnailDots: {
    },
    thumbnailGrid: {
      marginBottom: '7vh', // (window.screen.availHeight-166-theme.layout.footerbar.heightSm *3)/2 - 58*1.5 ,
      width: '100%',
      maxWidth: '100%',
      left: 0,
      transform: 'revert',
      padding: `${theme.spacing(2)}px 0px`,
      [theme.breakpoints.up('sm')]: {
        marginBottom: '23vh', // \(getHeight(theme, "portrait")-194-theme.layout.footerbar.height)/2 - 58*2 ,
        [theme.orientation.landscape]: {
          marginBottom: '16vh', // \(getHeight(theme, "landscape")-194-theme.layout.footerbar.height)/2 - 58*2  ,
        },
      },
    },
  }),
  { name: 'DesignerFullScreenView' },
);

export default (props) => {
  const { thumbnailDots, ...classes } = useStyles(props);

  return (
    <FullScreenView
      classes={classes}
      thumbnailProps={{
        classes: {
          dots: thumbnailDots,
        },
      }}
      {...props}
    />
  );
};
